import { render, staticRenderFns } from "./info.vue?vue&type=template&id=9fbba2b8"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./info.vue?vue&type=custom&index=0&blockType=Button&disabled=true&v-else=true"
if (typeof block0 === 'function') block0(component)
import block1 from "./info.vue?vue&type=custom&index=1&blockType=Row&align=middle&style=margin-bottom%3A%2020px&v-if=status%20%3D%3D%3D%20'4'"
if (typeof block1 === 'function') block1(component)
import block2 from "./info.vue?vue&type=custom&index=2&blockType=Table&ref=selection&%3Acolumns=columns&%3Adata=data1&%3Aloading=loading&%40on-selection-change=changeSelection"
if (typeof block2 === 'function') block2(component)
import block3 from "./info.vue?vue&type=custom&index=3&blockType=div&style=display%3A%20flex%3B%20align-items%3A%20center%3B%20margin-top%3A%2020px"
if (typeof block3 === 'function') block3(component)
import block4 from "./info.vue?vue&type=custom&index=4&blockType=Modal&v-model=showResumeModal&%3Awidth=700&%3Afooter-hide=true&title=%E6%9F%A5%E7%9C%8B%E7%AE%80%E5%8E%86"
if (typeof block4 === 'function') block4(component)

export default component.exports